import React, { useState, useEffect } from 'react';
import Icon from '../AppIcon';

const RealTimeStatusBadge = ({ 
  connectionStatus = 'connected', 
  lastUpdate = null,
  className = '' 
}) => {
  const [currentTime, setCurrentTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const getStatusConfig = () => {
    switch (connectionStatus) {
      case 'connected':
        return {
          icon: 'Wifi',
          color: 'text-success',
          bgColor: 'bg-success/10',
          label: 'Live',
          dotClass: 'status-online'
        };
      case 'connecting':
        return {
          icon: 'Loader2',
          color: 'text-warning',
          bgColor: 'bg-warning/10',
          label: 'Connecting',
          dotClass: 'status-degraded'
        };
      case 'disconnected':
        return {
          icon: 'WifiOff',
          color: 'text-error',
          bgColor: 'bg-error/10',
          label: 'Offline',
          dotClass: 'status-offline'
        };
      default:
        return {
          icon: 'Wifi',
          color: 'text-muted-foreground',
          bgColor: 'bg-muted',
          label: 'Unknown',
          dotClass: 'bg-muted-foreground'
        };
    }
  };

  const getTimeSinceUpdate = () => {
    if (!lastUpdate) return null;
    
    const diff = Math.floor((currentTime - new Date(lastUpdate)) / 1000);
    
    if (diff < 60) return `${diff}s ago`;
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    return `${Math.floor(diff / 3600)}h ago`;
  };

  const statusConfig = getStatusConfig();
  const timeSince = getTimeSinceUpdate();

  return (
    <div className={`flex items-center space-x-2 ${className}`}>
      {/* Status Indicator */}
      <div className={`flex items-center space-x-1.5 px-2 py-1 rounded-full ${statusConfig?.bgColor}`}>
        <div className={`status-indicator ${statusConfig?.dotClass}`}></div>
        <span className={`text-xs font-medium ${statusConfig?.color}`}>
          {statusConfig?.label}
        </span>
      </div>
      {/* Last Update Time */}
      {timeSince && connectionStatus === 'connected' && (
        <div className="flex items-center space-x-1 text-xs text-muted-foreground">
          <Icon name="Clock" size={12} />
          <span>{timeSince}</span>
        </div>
      )}
      {/* Connection Icon for Mobile */}
      <div className="sm:hidden">
        <Icon 
          name={statusConfig?.icon} 
          size={14} 
          className={`${statusConfig?.color} ${connectionStatus === 'connecting' ? 'animate-spin' : ''}`}
        />
      </div>
    </div>
  );
};

export default RealTimeStatusBadge;